<template>
  <div class="u-flex-full u-flex-wrap">
    <div class="u-flex-full">
      <sc-placeholder name="jss-link-section" :rendering="rendering" />
    </div>
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      class="c-cta--secondary u-align-bottom"
      :class="fields.link.value.class"
    />
  </div>
</template>

<script>
import { Placeholder, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-FullWidthLinks',
  components: {
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
